import * as types from "./../types";


const initialState = {
    error: null,
    panUploadStage: {
      loading: false,
      isSubmitedSuccess: false
    }
}

const PanUploadReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.SET_PAN_UPLOAD_ERROR:
        return {
          ...state,
          error: action.payload
        };
      case types.RESET_PAN_UPLOAD_ERROR:
        return {
          ...state,
          error: null
        }
      case types.SET_PAN_UPLOADING_IN_PROGRESS:
        return {
          ...state,
          panUploadStage: action.payload
        }
      default:
        return state;
    }
};
export default PanUploadReducer;